import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import block from 'bem-cn'
import { AnimatePresence, motion } from 'framer-motion'

import { selectLocaleDict } from 'features/locale/selectors'

import './Spinner.scss'

interface ISpinnerProps {
  isLoading: boolean
  size?: string
  zIndex?: number
}

export const Spinner: React.FC<ISpinnerProps> = ({ isLoading, size = 'small', zIndex = 10 }) => {
  const b = block('spinner')

  const locale = useSelector(selectLocaleDict, shallowEqual).common

  return (
    <AnimatePresence exitBeforeEnter>
      {isLoading ? (
        <motion.div
          animate={{ opacity: 1 }}
          initial={{ opacity: 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          style={{ zIndex }}
          className={b({ size })}>
          <div className={b('wrapper')}>
            <div className={b('circle')} />
            <div className={b('label')}>{locale.loading}</div>
          </div>
        </motion.div>
      ) : null}
      ;
    </AnimatePresence>
  )
}
